import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { 
  Map, FileText, Eye, Clock, CheckCircle, AlertCircle, 
  MoreVertical, ArrowUpRight, Sparkles 
} from 'lucide-react';

const DashboardHome = () => {
  const [stats, setStats] = useState({
      total_routes: 12,
      total_blogs: 8,
      total_views: 3450,
      recent_activity: [
        { id: 101, title: "Sultanahmet ve Çevresi", type: "Rota", status: "published", date: "Bugün, 14:30" },
        { id: 102, title: "Kapadokya Gezi Rehberi", type: "Blog", status: "draft", date: "Dün" },
        { id: 103, title: "Ege'nin Saklı Köyleri", type: "Rota", status: "review", date: "2 gün önce" },
        { id: 104, title: "Mardin Mimarisi", type: "Blog", status: "published", date: "3 gün önce" },
      ]
    });

  const getStatusBadge = (status) => {
    switch (status) {
      case 'published':
        return <span className="flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-semibold bg-emerald-500/10 text-emerald-400 border border-emerald-500/20"><CheckCircle size={12} /> Yayında</span>;
      case 'draft':
        return <span className="flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-semibold bg-slate-700/50 text-slate-400 border border-slate-600/50"><Clock size={12} /> Taslak</span>;
      case 'review':
        return <span className="flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-semibold bg-amber-500/10 text-amber-500 border border-amber-500/20"><AlertCircle size={12} /> İncelemede</span>;
      default: return null;
    }
  };

  return (
    <div className="space-y-8 animate-in fade-in duration-500">
      
      {/* Header */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-6 pb-2">
        <div>
          <h1 className="text-3xl font-bold text-white flex items-center gap-2">
            Panel Özeti <Sparkles className="w-5 h-5 text-indigo-400" />
          </h1>
          <p className="text-slate-400 mt-2 text-sm">
            Mekânname içeriklerinizi yönetin, istatistikleri takip edin.
          </p>
        </div>
        
        <div className="flex gap-3 w-full md:w-auto">
          <Link to="/editor/create-route" className="flex-1 md:flex-none justify-center flex items-center gap-2 bg-indigo-600 hover:bg-indigo-500 text-white px-5 py-2.5 rounded-lg transition-all shadow-lg shadow-indigo-500/20 font-medium text-sm active:scale-95">
            <Map size={16} /> Yeni Rota
          </Link>
          <Link to="/editor/write-blog" className="flex-1 md:flex-none justify-center flex items-center gap-2 bg-slate-800 hover:bg-slate-700 text-slate-200 border border-slate-700 hover:border-slate-600 px-5 py-2.5 rounded-lg transition-all font-medium text-sm active:scale-95">
            <FileText size={16} /> Blog Yaz
          </Link>
        </div>
      </div>

      {/* İstatistik Kartları */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Rota Kartı */}
        <div className="bg-slate-800 p-6 rounded-2xl border border-slate-700 shadow-sm hover:border-indigo-500/30 transition-all group">
          <div className="flex justify-between items-start mb-4">
            <div className="p-3 bg-slate-900/50 rounded-xl border border-slate-700/50 group-hover:border-indigo-500/30 group-hover:bg-indigo-500/10 transition-colors">
              <Map className="w-6 h-6 text-slate-400 group-hover:text-indigo-400" />
            </div>
            <span className="flex items-center gap-1 text-xs font-medium text-emerald-400 bg-emerald-500/10 px-2 py-1 rounded-full border border-emerald-500/10">
              <ArrowUpRight size={12} /> +2 bu hafta
            </span>
          </div>
          <h3 className="text-3xl font-bold text-white">{stats.total_routes}</h3>
          <p className="text-slate-400 text-sm mt-1 font-medium">Oluşturulan Rota</p>
        </div>

        {/* Blog Kartı */}
        <div className="bg-slate-800 p-6 rounded-2xl border border-slate-700 shadow-sm hover:border-indigo-500/30 transition-all group">
          <div className="flex justify-between items-start mb-4">
            <div className="p-3 bg-slate-900/50 rounded-xl border border-slate-700/50 group-hover:border-emerald-500/30 group-hover:bg-emerald-500/10 transition-colors">
              <FileText className="w-6 h-6 text-slate-400 group-hover:text-emerald-400" />
            </div>
            <span className="flex items-center gap-1 text-xs font-medium text-emerald-400 bg-emerald-500/10 px-2 py-1 rounded-full border border-emerald-500/10">
              <ArrowUpRight size={12} /> +1 bu hafta
            </span>
          </div>
          <h3 className="text-3xl font-bold text-white">{stats.total_blogs}</h3>
          <p className="text-slate-400 text-sm mt-1 font-medium">Yayınlanan Yazı</p>
        </div>

        {/* Etkileşim Kartı */}
        <div className="bg-slate-800 p-6 rounded-2xl border border-slate-700 shadow-sm hover:border-indigo-500/30 transition-all group">
          <div className="flex justify-between items-start mb-4">
            <div className="p-3 bg-slate-900/50 rounded-xl border border-slate-700/50 group-hover:border-blue-500/30 group-hover:bg-blue-500/10 transition-colors">
              <Eye className="w-6 h-6 text-slate-400 group-hover:text-blue-400" />
            </div>
            <span className="flex items-center gap-1 text-xs font-medium text-emerald-400 bg-emerald-500/10 px-2 py-1 rounded-full border border-emerald-500/10">
              <ArrowUpRight size={12} /> %12 artış
            </span>
          </div>
          <h3 className="text-3xl font-bold text-white">{stats.total_views}</h3>
          <p className="text-slate-400 text-sm mt-1 font-medium">Toplam Görüntülenme</p>
        </div>
      </div>

      {/* Tablo */}
      <div className="bg-slate-800 border border-slate-700 rounded-2xl overflow-hidden shadow-sm">
        <div className="p-6 border-b border-slate-700 flex justify-between items-center bg-slate-800/50">
          <h3 className="text-lg font-semibold text-white">Son Aktiviteler</h3>
          <button className="text-xs font-medium text-indigo-400 hover:text-indigo-300 transition-colors">Tümünü Gör</button>
        </div>
        
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead>
              <tr className="bg-slate-900/30 text-slate-400 text-xs uppercase tracking-wider">
                <th className="px-6 py-4 font-semibold">İçerik Başlığı</th>
                <th className="px-6 py-4 font-semibold">Tür</th>
                <th className="px-6 py-4 font-semibold">Durum</th>
                <th className="px-6 py-4 font-semibold">Tarih</th>
                <th className="px-6 py-4 text-right"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-700/50">
              {stats.recent_activity.map((item) => (
                <tr key={item.id} className="hover:bg-slate-700/30 transition-colors group">
                  <td className="px-6 py-4">
                    <p className="font-medium text-slate-200 group-hover:text-indigo-300 transition-colors">{item.title}</p>
                  </td>
                  <td className="px-6 py-4">
                    <span className={`text-xs px-2.5 py-1 rounded-md border font-medium ${item.type === 'Rota' ? 'bg-indigo-500/10 text-indigo-300 border-indigo-500/20' : 'bg-emerald-500/10 text-emerald-300 border-emerald-500/20'}`}>
                      {item.type}
                    </span>
                  </td>
                  <td className="px-6 py-4">{getStatusBadge(item.status)}</td>
                  <td className="px-6 py-4 text-sm text-slate-500 font-medium tabular-nums">{item.date}</td>
                  <td className="px-6 py-4 text-right">
                    <button className="text-slate-500 hover:text-white p-2 hover:bg-slate-700 rounded-lg transition-colors">
                      <MoreVertical size={18} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DashboardHome;